import React, { useEffect } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { useRouter } from 'expo-router';
import { SafeAreaView } from 'react-native-safe-area-context';

import { Text } from '@/components/ui/text';
import { useTranslation } from '@/hooks/useTranslation';
import B2BPlanSelectionScreenEnhanced from '../../src/screens/b2b/B2BPlanSelectionScreenEnhanced';
import { useAuth } from '../../src/context/AuthContext';
import { ROUTES } from '../../src/navigation/routes';

export default function B2BPlanSelectionRoute() {
  const { t } = useTranslation();
  const router = useRouter();
  const { user, phase } = useAuth();

  const normalizedUserType = (user?.user_type || '').toLowerCase();
  const isB2BAdmin = normalizedUserType === 'b2b2c_admin';

  useEffect(() => {
    if (user && !isB2BAdmin && phase !== 'loading') {
      // If a non-school admin somehow lands on this route (e.g. after cancel flow),
      // send them back to the regular plan selection paywall so we don't render the
      // wrong screen and crash React with an invalid tree.
      router.replace(ROUTES.GATED_PLAN_SELECTION as any);
    }
  }, [user, isB2BAdmin, phase, router]);

  if (!user || phase === 'loading') {
    return (
      <View className="flex-1 items-center justify-center bg-background">
        <ActivityIndicator size="large" />
        <Text className="mt-4 text-muted-foreground">{t('common.loading')}</Text>
      </View>
    );
  }

  if (!isB2BAdmin) {
    return (
      <SafeAreaView className="flex-1 items-center justify-center bg-background px-6">
        <ActivityIndicator size="large" />
        <Text className="mt-4 text-center text-muted-foreground">
          {t('b2bPlanSelection.redirecting')}
        </Text>
      </SafeAreaView>
    );
  }

  return <B2BPlanSelectionScreenEnhanced />;
}
